// @flow
import * as React from 'react';
import { SubmitButton } from '../../Common';
import { ModerationState } from '../../../models';
import ObservationBadges, { PwrModerationTime } from '../ObservationBadges';
import ActionAsideSection from './ActionAsideSection';
import {
  actionAside as actionAsideCss,
  actionAsideSectionCustomObservationHeader as actionAsideCOHeadingCss,
  actionAsideSectionMerchantNameSubheader as actionAsideMerchantNameHeadingCss,
} from './ActionAside.scss';

const ActionAsideModerated = (props: {
  pending: boolean,
  onSubmit: Function,
  standardObservationButtons: Array<React.Element<any>>,
  customObservationButtons: Array<React.Element<any>>,
  moderationState: ModerationState,
  merchantName: string,
}) => {
  const {
    pending,
    onSubmit,
    standardObservationButtons,
    customObservationButtons,
    moderationState,
    merchantName,
  } = props;

  return (
    <div className={actionAsideCss}>
      <ActionAsideSection.First>
        <SubmitButton
          pending={pending}
          onClick={onSubmit}
          label={'Save'}
          disabled={!ModerationState.isModified(moderationState, 1)}
          className="w-100"
        />
      </ActionAsideSection.First>

      <ActionAsideSection>
        <PwrModerationTime moderationState={moderationState} />
        <ObservationBadges moderationState={moderationState} />
      </ActionAsideSection>

      {customObservationButtons.length > 0 && (
        <ActionAsideSection>
          <h3 className={actionAsideCOHeadingCss}>Custom Observations for:</h3>
          <p className={actionAsideMerchantNameHeadingCss}>{merchantName}</p>
          {customObservationButtons}
        </ActionAsideSection>
      )}

      <ActionAsideSection heading="Standard Observations">
        {standardObservationButtons}
      </ActionAsideSection>
    </div>
  );
};

export default ActionAsideModerated;



// WEBPACK FOOTER //
// ./src/components/ModerationCard/PowerReviewsModerationCard/ActionAsideModerated.js